// frontend/src/context/NotificationContext.js
import React, { createContext, useContext } from 'react';
import { App as AntApp } from 'antd';

// Create the context
const NotificationContext = createContext(null);

// This is the provider component that will wrap our app
export const NotificationProvider = ({ children }) => {
    const { message, modal, notification } = AntApp.useApp();

    // We create a new object with the familiar API, but using the hooked instances
    const api = {
        message: {
            success: (content) => message.success(content),
            error: (content) => message.error(content),
            warning: (content) => message.warning(content),
            // You can add more methods if you need them
        },
        modal: {
            confirm: (config) => modal.confirm(config),
            // Add others like .info, .success if needed
        },
        notification
    };

    return (
        <NotificationContext.Provider value={api}>
            {children}
        </NotificationContext.Provider>
    );
};

// This is the custom hook that our components will use
export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};